import Mensajes from './Mensajes';

export default Mensajes;
